import { additionalSlice, handleOpenTicketsRefetch } from './store/ticket.slice';

export const { setSeeMoreTicket } = additionalSlice.actions;

export {
  additionalSlice,
  handleOpenTicketsRefetch,
};
